const APP_STORE_URL = 'https://apps.apple.com/us/app/10-thirty/id1639117437';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=co.za.callitservices.tenthirty&pcampaignid=web_share';

export function getDownloadUrl() {
  if (typeof navigator === 'undefined') {
    return APP_STORE_URL;
  }

  const userAgent = navigator.userAgent || '';
  return /android/i.test(userAgent) ? PLAY_STORE_URL : APP_STORE_URL;
}

export { APP_STORE_URL, PLAY_STORE_URL };
